var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnalytics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 325.41 306.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#radial-gradient);}.cls-2{fill:url(#New_Gradient_Swatch_1);}.cls-3{isolation:isolate;}.cls-162,.cls-33,.cls-34,.cls-35,.cls-4{opacity:0.2;}.cls-5{fill:url(#linear-gradient);}.cls-6{fill:url(#linear-gradient-2);}.cls-11,.cls-25,.cls-38,.cls-7,.cls-74,.cls-79,.cls-84,.cls-89,.cls-94,.cls-96{mix-blend-mode:multiply;}.cls-106,.cls-48,.cls-7{opacity:0.82;}.cls-7{fill:url(#linear-gradient-3);}.cls-13,.cls-171,.cls-174,.cls-53,.cls-8{mix-blend-mode:screen;}.cls-13,.cls-8{opacity:0.6;}.cls-8{fill:url(#radial-gradient-2);}.cls-9{fill:url(#linear-gradient-4);}.cls-10{fill:url(#linear-gradient-5);}.cls-11{fill:#bcbec0;}.cls-12{fill:url(#linear-gradient-6);}.cls-13{fill:url(#radial-gradient-3);}.cls-14,.cls-39,.cls-97{opacity:0;}.cls-15{mask:url(#mask);}.cls-16,.cls-18,.cls-32,.cls-36{opacity:0.9;}.cls-17{fill:url(#New_Gradient_Swatch_copy_36);}.cls-18{fill:url(#New_Gradient_Swatch_copy_36-2);}.cls-19{fill:url(#linear-gradient-7);}.cls-20,.cls-21{opacity:0.85;}.cls-20{fill:url(#New_Gradient_Swatch_copy_36-3);}.cls-21{fill:url(#New_Gradient_Swatch_copy_36-4);}.cls-110,.cls-155,.cls-158,.cls-169,.cls-22,.cls-24,.cls-30,.cls-37,.cls-52,.cls-75,.cls-80,.cls-85,.cls-90,.cls-95{mix-blend-mode:color-dodge;}.cls-22{fill:url(#Radial_Gradient_1);}.cls-23{fill:url(#New_Gradient_Swatch_copy_36-5);}.cls-24{fill:url(#Radial_Gradient_1-2);}.cls-25{fill:url(#radial-gradient-4);}.cls-26,.cls-28,.cls-29{opacity:0.95;}.cls-27{fill:url(#New_Gradient_Swatch_copy_18);}.cls-28{fill:url(#New_Gradient_Swatch_copy_18-2);}.cls-29{fill:url(#New_Gradient_Swatch_copy_9);}.cls-30{fill:url(#Radial_Gradient_1-3);}.cls-31{fill:url(#linear-gradient-8);}.cls-32{fill:url(#linear-gradient-9);}.cls-33{fill:url(#New_Gradient_Swatch_copy_36-6);}.cls-34{fill:url(#New_Gradient_Swatch_copy_18-3);}.cls-35{fill:url(#linear-gradient-10);}.cls-36{fill:url(#linear-gradient-11);}.cls-37{fill:url(#Radial_Gradient_1-4);}.cls-38{opacity:0.3;}.cls-39{fill:url(#linear-gradient-12);}.cls-40,.cls-98{opacity:0.09;}.cls-40{fill:url(#linear-gradient-13);}.cls-41,.cls-99{opacity:0.18;}.cls-41{fill:url(#linear-gradient-14);}.cls-100,.cls-42{opacity:0.27;}.cls-42{fill:url(#linear-gradient-15);}.cls-101,.cls-43{opacity:0.36;}.cls-43{fill:url(#linear-gradient-16);}.cls-102,.cls-44{opacity:0.45;}.cls-44{fill:url(#linear-gradient-17);}.cls-103,.cls-45{opacity:0.55;}.cls-45{fill:url(#linear-gradient-18);}.cls-104,.cls-46{opacity:0.64;}.cls-46{fill:url(#linear-gradient-19);}.cls-105,.cls-47{opacity:0.73;}.cls-47{fill:url(#linear-gradient-20);}.cls-48{fill:url(#linear-gradient-21);}.cls-107,.cls-49{opacity:0.91;}.cls-49{fill:url(#linear-gradient-22);}.cls-50{fill:url(#linear-gradient-23);}.cls-109,.cls-51{opacity:0.8;}.cls-51{fill:url(#New_Gradient_Swatch_copy_26);}.cls-52{fill:url(#radial-gradient-5);}.cls-54{fill:url(#linear-gradient-24);}.cls-55{fill:url(#linear-gradient-25);}.cls-56{fill:url(#linear-gradient-26);}.cls-57{fill:url(#linear-gradient-27);}.cls-58{fill:url(#linear-gradient-28);}.cls-59{fill:url(#linear-gradient-29);}.cls-60{fill:url(#linear-gradient-30);}.cls-61{fill:url(#linear-gradient-31);}.cls-62{fill:url(#linear-gradient-32);}.cls-63{fill:#fff;}.cls-64{opacity:0.15;}.cls-65{fill:url(#linear-gradient-33);}.cls-66{fill:#4b61b8;}.cls-67{fill:url(#linear-gradient-34);}.cls-68{fill:url(#linear-gradient-35);}.cls-69{fill:url(#linear-gradient-36);}.cls-70{fill:url(#linear-gradient-37);}.cls-71{fill:url(#linear-gradient-38);}.cls-72{fill:url(#linear-gradient-39);}.cls-73{fill:url(#linear-gradient-40);}.cls-74{fill:url(#linear-gradient-41);}.cls-75{fill:url(#Radial_Gradient_1-5);}.cls-76{fill:url(#linear-gradient-42);}.cls-77{fill:url(#linear-gradient-43);}.cls-78{fill:url(#linear-gradient-44);}.cls-79{fill:url(#linear-gradient-45);}.cls-80{fill:url(#Radial_Gradient_1-6);}.cls-81{fill:url(#linear-gradient-46);}.cls-82{fill:url(#linear-gradient-47);}.cls-83{fill:url(#linear-gradient-48);}.cls-84{fill:url(#linear-gradient-49);}.cls-85{fill:url(#Radial_Gradient_1-7);}.cls-86{fill:url(#linear-gradient-50);}.cls-87{fill:url(#linear-gradient-51);}.cls-88{fill:url(#linear-gradient-52);}.cls-89{fill:url(#linear-gradient-53);}.cls-90{fill:url(#Radial_Gradient_1-8);}.cls-91{fill:url(#linear-gradient-54);}.cls-92{fill:url(#linear-gradient-55);}.cls-93{fill:url(#linear-gradient-56);}.cls-94{fill:url(#linear-gradient-57);}.cls-95{fill:url(#Radial_Gradient_1-9);}.cls-171,.cls-96{opacity:0.5;}.cls-97{fill:url(#linear-gradient-58);}.cls-98{fill:url(#linear-gradient-59);}.cls-99{fill:url(#linear-gradient-60);}.cls-100{fill:url(#linear-gradient-61);}.cls-101{fill:url(#linear-gradient-62);}.cls-102{fill:url(#linear-gradient-63);}.cls-103{fill:url(#linear-gradient-64);}.cls-104{fill:url(#linear-gradient-65);}.cls-105{fill:url(#linear-gradient-66);}.cls-106{fill:url(#linear-gradient-67);}.cls-107{fill:url(#linear-gradient-68);}.cls-108{fill:url(#linear-gradient-69);}.cls-109{fill:url(#New_Gradient_Swatch_copy_26-2);}.cls-110{fill:url(#radial-gradient-6);}.cls-111{fill:url(#New_Gradient_Swatch_copy_8);}.cls-112{fill:url(#New_Gradient_Swatch_copy_8-2);}.cls-113{fill:url(#New_Gradient_Swatch_copy_8-3);}.cls-114{fill:url(#New_Gradient_Swatch_copy_8-4);}.cls-115{fill:url(#New_Gradient_Swatch_copy_8-5);}.cls-116{fill:url(#New_Gradient_Swatch_copy_8-6);}.cls-117{fill:url(#New_Gradient_Swatch_copy_8-7);}.cls-118{fill:url(#New_Gradient_Swatch_copy_8-8);}.cls-119{fill:url(#New_Gradient_Swatch_copy_8-9);}.cls-120{fill:url(#New_Gradient_Swatch_copy_8-10);}.cls-121{fill:url(#New_Gradient_Swatch_copy_8-11);}.cls-122{fill:url(#New_Gradient_Swatch_copy_8-12);}.cls-123{fill:url(#New_Gradient_Swatch_copy_8-13);}.cls-124{fill:url(#New_Gradient_Swatch_copy_9-2);}.cls-125{fill:url(#New_Gradient_Swatch_copy_9-3);}.cls-126{fill:url(#New_Gradient_Swatch_copy_9-4);}.cls-127{fill:url(#New_Gradient_Swatch_copy_9-5);}.cls-128{fill:url(#New_Gradient_Swatch_copy_9-6);}.cls-129{fill:url(#New_Gradient_Swatch_copy_9-7);}.cls-130{fill:url(#New_Gradient_Swatch_copy_9-8);}.cls-131{fill:url(#New_Gradient_Swatch_copy_9-9);}.cls-132{fill:url(#New_Gradient_Swatch_copy_9-10);}.cls-133{fill:url(#New_Gradient_Swatch_copy_9-11);}.cls-134{fill:url(#linear-gradient-70);}.cls-135{fill:url(#linear-gradient-71);}.cls-136{fill:url(#linear-gradient-72);}.cls-137{fill:url(#linear-gradient-73);}.cls-138{fill:url(#linear-gradient-74);}.cls-139{fill:url(#linear-gradient-75);}.cls-140{fill:url(#linear-gradient-76);}.cls-141{fill:url(#linear-gradient-77);}.cls-142{fill:url(#linear-gradient-78);}.cls-143{fill:url(#linear-gradient-79);}.cls-144{fill:url(#New_Gradient_Swatch_copy_9-12);}.cls-145{fill:url(#New_Gradient_Swatch_copy_9-13);}.cls-146{fill:url(#New_Gradient_Swatch_copy_9-14);}.cls-147{fill:url(#linear-gradient-80);}.cls-148{fill:url(#linear-gradient-81);}.cls-149{fill:url(#linear-gradient-82);}.cls-150{fill:url(#New_Gradient_Swatch_copy_9-15);}.cls-151{fill:url(#New_Gradient_Swatch_copy_9-16);}.cls-152{fill:url(#New_Gradient_Swatch_copy_9-17);}.cls-153{fill:url(#linear-gradient-83);}.cls-154{fill:url(#New_Gradient_Swatch_copy_26-3);}.cls-155{fill:url(#radial-gradient-7);}.cls-156{fill:url(#New_Gradient_Swatch_copy_33);}.cls-157{fill:url(#linear-gradient-84);}.cls-158{fill:url(#radial-gradient-8);}.cls-159{fill:url(#New_Gradient_Swatch_copy_13);}.cls-160{fill:url(#linear-gradient-85);}.cls-161{mask:url(#mask-2);}.cls-162{fill:url(#New_Gradient_Swatch_copy_33-2);}.cls-163{clip-path:url(#clip-path);}.cls-164{fill:url(#New_Gradient_Swatch_copy_9-18);}.cls-165{fill:url(#New_Gradient_Swatch_copy_9-19);}.cls-166{fill:url(#New_Gradient_Swatch_copy_9-20);}.cls-167{fill:url(#linear-gradient-86);}.cls-168{fill:url(#New_Gradient_Swatch_copy_26-4);}.cls-169{fill:url(#radial-gradient-9);}.cls-170{fill:url(#linear-gradient-87);}.cls-171{fill:url(#radial-gradient-10);}.cls-172{fill:url(#linear-gradient-88);}.cls-173{fill:url(#linear-gradient-89);}.cls-174{fill:url(#Radial_Gradient_1-10);}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 398.23,
    cy: 253.85,
    r: 61.11,
    gradientTransform: "translate(0 8.91) scale(1 1.07)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#e4e4e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#c3c4c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#959799"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808285"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1",
    x1: 3159.95,
    y1: 245.48,
    x2: 3159.95,
    y2: 250.66,
    gradientTransform: "matrix(1, 0, 0, -1, -2880.33, 589.09)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 6529.77,
    y1: 291.92,
    x2: 6647.41,
    y2: 291.92,
    gradientTransform: "translate(-6090.37)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#210243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#25084b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#2c1358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#311b61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#341d65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3c2273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#492b88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#5b38a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#653fb8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#5f3aae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#49298d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#391d75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#2f1666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#2c1361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#270c55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#220346"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200041"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 6561.25,
    y1: 299.48,
    x2: 6614.58,
    y2: 269.98,
    gradientTransform: "translate(-6090.37)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#311b61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#290f52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f001f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 6589.53,
    y1: 285.54,
    x2: 6600,
    y2: 267.99,
    gradientTransform: "translate(-6090.37)",
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 6589.88,
    cy: 309.39,
    r: 41.85,
    gradientTransform: "translate(-6090.37)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#af8afc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 6675.86,
    y1: 320.2,
    x2: 6495.83,
    y2: 71.09,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 6520.18,
    y1: 95.9,
    x2: 6673.35,
    y2: 326.22,
    gradientTransform: "translate(-6090.37)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 6714.12,
    y1: 325.61,
    x2: 6572.41,
    y2: 99.19,
    gradientTransform: "translate(-6090.37)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#210243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#25084b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#2c1358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#311b61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#351f65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#422c73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#584188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#765fa7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#8770b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#7e67ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#5c468d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#442e75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#362066"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#311b61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#2a1155"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#230446"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200041"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 6673.91,
    cy: 196.67,
    r: 24.12,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 74.32,
    y: 157.45,
    width: 95.39,
    height: 106.61,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-275.44 -84.33)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 349.77,
    y: 241.78,
    width: 95.39,
    height: 106.61
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_36",
    x1: 431.67,
    y1: 275.33,
    x2: 399.87,
    y2: 314.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7c1dc9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_36-2",
    x1: 81.94,
    y1: 188.76,
    x2: 107.62,
    y2: 239.81,
    xlinkHref: "#New_Gradient_Swatch_copy_36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 384.08,
    y1: 296.72,
    x2: 413.51,
    y2: 296.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#5d16a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#501397"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_36-3",
    x1: 363.56,
    y1: 309.24,
    x2: 438.26,
    y2: 309.24,
    xlinkHref: "#New_Gradient_Swatch_copy_36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_36-4",
    x1: 131.35,
    y1: 217.45,
    x2: 162.48,
    y2: 245.74,
    xlinkHref: "#New_Gradient_Swatch_copy_36"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1",
    cx: 424.08,
    cy: 294.41,
    r: 12.02,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_36-5",
    x1: 431.67,
    y1: 245.23,
    x2: 399.87,
    y2: 284.69,
    xlinkHref: "#New_Gradient_Swatch_copy_36"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-2",
    cx: 402.12,
    cy: 274.7,
    r: 19.64,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 8474.78,
    cy: -4165.83,
    r: 9.48,
    gradientTransform: "matrix(-1.18, 0, 0, 0.49, 10132.05, 2251.67)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#785c5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_18",
    x1: 398.81,
    y1: 317.99,
    x2: 409.39,
    y2: 317.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#ae25b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#d744bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#ff63ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#dc48c1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_18-2",
    x1: 358.83,
    y1: 326.49,
    x2: 437.59,
    y2: 326.49,
    xlinkHref: "#New_Gradient_Swatch_copy_18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9",
    x1: 431.33,
    y1: 292.28,
    x2: 403.76,
    y2: 330.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#ae25b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#d744bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-3",
    cx: 412.41,
    cy: 324.78,
    r: 11.83,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 384.08,
    y1: 310.59,
    x2: 398.85,
    y2: 310.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#671ab9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#ad34f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5513ab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 358.58,
    y1: 317.9,
    x2: 438.91,
    y2: 317.9,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_36-6",
    x1: 363.56,
    y1: 328.24,
    x2: 438.26,
    y2: 328.24,
    xlinkHref: "#New_Gradient_Swatch_copy_36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_18-3",
    x1: 358.83,
    y1: 335.92,
    x2: 437.59,
    y2: 335.92,
    xlinkHref: "#New_Gradient_Swatch_copy_18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 358.58,
    y1: 331.55,
    x2: 438.91,
    y2: 331.55,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 401.91,
    y1: 278.97,
    x2: 373.01,
    y2: 315.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5513ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#be3bff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-4",
    cx: 379.99,
    cy: 312.62,
    r: 15.9,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 5718.63,
    y1: 85.77,
    x2: 5797.21,
    y2: 235.6,
    gradientTransform: "translate(-5231.6)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 5718.13,
    y1: 86.12,
    x2: 5796.53,
    y2: 235.62,
    gradientTransform: "translate(-5231.6)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 5717.63,
    y1: 86.48,
    x2: 5795.86,
    y2: 235.63,
    gradientTransform: "translate(-5231.6)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 5717.14,
    y1: 86.84,
    x2: 5795.18,
    y2: 235.65,
    gradientTransform: "translate(-5231.6)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 5716.65,
    y1: 87.19,
    x2: 5794.51,
    y2: 235.67,
    gradientTransform: "translate(-5231.6)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 5716.16,
    y1: 87.55,
    x2: 5793.84,
    y2: 235.68,
    gradientTransform: "translate(-5231.6)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 5715.67,
    y1: 87.9,
    x2: 5793.17,
    y2: 235.7,
    gradientTransform: "translate(-5231.6)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 5715.18,
    y1: 88.26,
    x2: 5792.51,
    y2: 235.71,
    gradientTransform: "translate(-5231.6)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 5714.69,
    y1: 88.61,
    x2: 5791.84,
    y2: 235.72,
    gradientTransform: "translate(-5231.6)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 5714.21,
    y1: 88.96,
    x2: 5791.18,
    y2: 235.73,
    gradientTransform: "translate(-5231.6)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 5713.72,
    y1: 89.31,
    x2: 5790.52,
    y2: 235.74,
    gradientTransform: "translate(-5231.6)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 5713.24,
    y1: 89.66,
    x2: 5789.86,
    y2: 235.76,
    gradientTransform: "translate(-5231.6)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_26",
    x1: 5824.64,
    y1: 307.06,
    x2: 5702.33,
    y2: 68.11,
    gradientTransform: "translate(-5231.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#6e41d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#4c9be8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 5774,
    cy: 154.41,
    r: 52.72,
    gradientTransform: "translate(-5231.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#a7a9aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#7b7c7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#555657"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#363737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#1e1f1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#0d0d0e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 2774.92,
    y1: 132.69,
    x2: 2765.49,
    y2: 180.9,
    gradientTransform: "matrix(-1, 0, 0, 1, 3317.49, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#2af6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e00d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 2755.18,
    y1: 189.94,
    x2: 2801.03,
    y2: 193.87,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 2790.59,
    y1: 177.94,
    x2: 2784.56,
    y2: 142.04,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 2801.37,
    y1: 160.65,
    x2: 2780.94,
    y2: 160.39,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 2767.23,
    y1: 207.42,
    x2: 2765.66,
    y2: 261.39,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 2748.4,
    y1: 235.06,
    x2: 2787.96,
    y2: 271.22,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 2772.56,
    y1: 256.61,
    x2: 2808.2,
    y2: 229.36,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 2785.01,
    y1: 221.24,
    x2: 2793.39,
    y2: 257.92,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 2771.22,
    y1: 247.87,
    x2: 2792.18,
    y2: 208.05,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: -350.06,
    y1: 344.3,
    x2: -333.37,
    y2: 329.89,
    gradientTransform: "translate(590.56 -84.33)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#ffe4a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#fac098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#a142b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#7926cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#703ed1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6165db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#4c9ce9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#32e1fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: -339.46,
    y1: 358.74,
    x2: -315.97,
    y2: 338.46,
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: -328.69,
    y1: 372.21,
    x2: -298.4,
    y2: 346.06,
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: -318.1,
    y1: 386.66,
    x2: -281,
    y2: 354.64,
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: -306.99,
    y1: 400.15,
    x2: -263.08,
    y2: 362.25,
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 6011.08,
    y1: 320.04,
    x2: 6054.41,
    y2: 272,
    gradientTransform: "matrix(-1, 0, 0, 1, 6267.78, -84.33)",
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 6017.14,
    y1: 314.8,
    x2: 6017.39,
    y2: 339.8,
    gradientTransform: "matrix(-1, 0, 0, 1, 6267.78, -84.33)",
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 6007.24,
    y1: 311.67,
    x2: 6006.84,
    y2: 339.45,
    gradientTransform: "matrix(-1, 0, 0, 1, 6267.78, -84.33)",
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 6007.89,
    y1: 328.06,
    x2: 6000.12,
    y2: 318.45,
    gradientTransform: "matrix(-1, 0, 0, 1, 6267.78, -84.33)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-5",
    cx: 6003.61,
    cy: 322.86,
    r: 10.34,
    gradientTransform: "matrix(-1, 0, 0, 1, 6267.78, -84.33)",
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 5996.4,
    y1: 306.7,
    x2: 6039.72,
    y2: 258.66,
    gradientTransform: "matrix(-1, 0, 0, 1, 6267.78, -84.33)",
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 6002.39,
    y1: 306,
    x2: 6002.87,
    y2: 354.9,
    gradientTransform: "matrix(-1, 0, 0, 1, 6267.78, -84.33)",
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 5992.63,
    y1: 304.65,
    x2: 5991.91,
    y2: 354.71,
    gradientTransform: "matrix(-1, 0, 0, 1, 6267.78, -84.33)",
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 5994,
    y1: 326.88,
    x2: 5979.15,
    y2: 308.51,
    xlinkHref: "#linear-gradient-41"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-6",
    cx: 5988.93,
    cy: 315.02,
    r: 15.97,
    gradientTransform: "matrix(-1, 0, 0, 1, 6267.78, -84.33)",
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 5981.62,
    y1: 292.45,
    x2: 6024.94,
    y2: 244.41,
    gradientTransform: "matrix(-1, 0, 0, 1, 6267.78, -84.33)",
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 5987.5,
    y1: 291.99,
    x2: 5988.26,
    y2: 369.11,
    gradientTransform: "matrix(-1, 0, 0, 1, 6267.78, -84.33)",
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 5978.02,
    y1: 289.86,
    x2: 5976.88,
    y2: 368.82,
    gradientTransform: "matrix(-1, 0, 0, 1, 6267.78, -84.33)",
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 5980,
    y1: 324.71,
    x2: 5958.11,
    y2: 297.63,
    xlinkHref: "#linear-gradient-41"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-7",
    cx: 5974.15,
    cy: 306.23,
    r: 22.85,
    gradientTransform: "matrix(-1, 0, 0, 1, 6267.78, -84.33)",
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 5966.78,
    y1: 277.83,
    x2: 6010.1,
    y2: 229.8,
    gradientTransform: "matrix(-1, 0, 0, 1, 6267.78, -84.33)",
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 5972.56,
    y1: 277.63,
    x2: 5973.6,
    y2: 384.07,
    gradientTransform: "matrix(-1, 0, 0, 1, 6267.78, -84.33)",
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 5963.36,
    y1: 274.67,
    x2: 5961.78,
    y2: 383.68,
    gradientTransform: "matrix(-1, 0, 0, 1, 6267.78, -84.33)",
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 5965.98,
    y1: 322.65,
    x2: 5936.78,
    y2: 286.52,
    xlinkHref: "#linear-gradient-41"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-8",
    cx: 5959.31,
    cy: 297.29,
    r: 30.44,
    gradientTransform: "matrix(-1, 0, 0, 1, 6267.78, -84.33)",
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 5951.55,
    y1: 263.49,
    x2: 5994.87,
    y2: 215.45,
    gradientTransform: "matrix(-1, 0, 0, 1, 6267.78, -84.33)",
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 5957.22,
    y1: 263.53,
    x2: 5958.55,
    y2: 398.96,
    gradientTransform: "matrix(-1, 0, 0, 1, 6267.78, -84.33)",
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 5948.3,
    y1: 259.76,
    x2: 5946.3,
    y2: 398.47,
    gradientTransform: "matrix(-1, 0, 0, 1, 6267.78, -84.33)",
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 5951.56,
    y1: 320.71,
    x2: 5915.12,
    y2: 275.63,
    xlinkHref: "#linear-gradient-41"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-9",
    cx: 5944.08,
    cy: 288.55,
    r: 38.11,
    gradientTransform: "matrix(-1, 0, 0, 1, 6267.78, -84.33)",
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 365.49,
    y1: 18.39,
    x2: 463.81,
    y2: 205.86,
    gradientTransform: "translate(12.15)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 365.93,
    y1: 20.58,
    x2: 463.16,
    y2: 205.98,
    gradientTransform: "translate(12.15)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 366.38,
    y1: 22.77,
    x2: 462.52,
    y2: 206.09,
    gradientTransform: "translate(12.15)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 366.82,
    y1: 24.96,
    x2: 461.88,
    y2: 206.21,
    gradientTransform: "translate(12.15)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 367.27,
    y1: 27.15,
    x2: 461.23,
    y2: 206.32,
    gradientTransform: "translate(12.15)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 367.72,
    y1: 29.34,
    x2: 460.6,
    y2: 206.43,
    gradientTransform: "translate(12.15)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 368.17,
    y1: 31.53,
    x2: 459.96,
    y2: 206.55,
    gradientTransform: "translate(12.15)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 368.62,
    y1: 33.71,
    x2: 459.32,
    y2: 206.66,
    gradientTransform: "translate(12.15)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 369.08,
    y1: 35.9,
    x2: 458.69,
    y2: 206.77,
    gradientTransform: "translate(12.15)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 369.54,
    y1: 38.08,
    x2: 458.06,
    y2: 206.88,
    gradientTransform: "translate(12.15)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 370,
    y1: 40.27,
    x2: 457.43,
    y2: 206.99,
    gradientTransform: "translate(12.15)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 370.46,
    y1: 42.45,
    x2: 456.81,
    y2: 207.1,
    gradientTransform: "translate(12.15)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_26-2",
    x1: 518.47,
    y1: 323.37,
    x2: 375.7,
    y2: 44.46,
    gradientTransform: "translate(12.15)",
    xlinkHref: "#New_Gradient_Swatch_copy_26"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 440.75,
    cy: 133.34,
    r: 101.37,
    gradientTransform: "translate(12.15)",
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8",
    x1: 427.56,
    y1: 200.25,
    x2: 444.96,
    y2: 143.01,
    gradientTransform: "translate(-263.3 -84.33)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffa98c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#ffb892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#fee1a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8-2",
    x1: 434.31,
    y1: 200.87,
    x2: 454.73,
    y2: 133.69,
    xlinkHref: "#New_Gradient_Swatch_copy_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8-3",
    x1: 440.47,
    y1: 201.99,
    x2: 460.87,
    y2: 134.87,
    xlinkHref: "#New_Gradient_Swatch_copy_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8-4",
    x1: 414.38,
    y1: 197.09,
    x2: 433.24,
    y2: 135.05,
    xlinkHref: "#New_Gradient_Swatch_copy_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8-5",
    x1: 422.51,
    y1: 199.43,
    x2: 436.5,
    y2: 153.4,
    xlinkHref: "#New_Gradient_Swatch_copy_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8-6",
    x1: 449.64,
    y1: 203.24,
    x2: 471.28,
    y2: 132.06,
    xlinkHref: "#New_Gradient_Swatch_copy_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8-7",
    x1: 458.21,
    y1: 206.58,
    x2: 477.64,
    y2: 142.66,
    xlinkHref: "#New_Gradient_Swatch_copy_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8-8",
    x1: 405.12,
    y1: 195.33,
    x2: 426.34,
    y2: 125.53,
    xlinkHref: "#New_Gradient_Swatch_copy_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8-9",
    x1: 392.29,
    y1: 193.06,
    x2: 413.09,
    y2: 124.66,
    xlinkHref: "#New_Gradient_Swatch_copy_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8-10",
    x1: 398.24,
    y1: 193.22,
    x2: 416.47,
    y2: 133.27,
    xlinkHref: "#New_Gradient_Swatch_copy_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8-11",
    x1: 464.41,
    y1: 212.74,
    x2: 478.22,
    y2: 167.3,
    xlinkHref: "#New_Gradient_Swatch_copy_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8-12",
    x1: 470.64,
    y1: 214.55,
    x2: 484.63,
    y2: 168.53,
    xlinkHref: "#New_Gradient_Swatch_copy_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8-13",
    x1: 476.56,
    y1: 214.24,
    x2: 492.49,
    y2: 161.82,
    xlinkHref: "#New_Gradient_Swatch_copy_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-2",
    x1: 427.56,
    y1: 203.69,
    x2: 444.96,
    y2: 146.45,
    gradientTransform: "translate(-263.3 -84.33)",
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-3",
    x1: 435.23,
    y1: 205.62,
    x2: 452.76,
    y2: 147.95,
    gradientTransform: "translate(-263.3 -84.33)",
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-4",
    x1: 441.66,
    y1: 207.42,
    x2: 458.73,
    y2: 151.28,
    gradientTransform: "translate(-263.3 -84.33)",
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-5",
    x1: 414.38,
    y1: 200.53,
    x2: 433.24,
    y2: 138.49,
    gradientTransform: "translate(-263.3 -84.33)",
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-6",
    x1: 422.27,
    y1: 202.74,
    x2: 437,
    y2: 154.27,
    gradientTransform: "translate(-263.3 -84.33)",
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-7",
    x1: 450.14,
    y1: 208.17,
    x2: 469.62,
    y2: 144.1,
    gradientTransform: "translate(-263.3 -84.33)",
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-8",
    x1: 458.21,
    y1: 210.02,
    x2: 477.64,
    y2: 146.1,
    gradientTransform: "translate(-263.3 -84.33)",
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-9",
    x1: 406.17,
    y1: 198.57,
    x2: 424.57,
    y2: 138.04,
    gradientTransform: "translate(-263.3 -84.33)",
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-10",
    x1: 392.29,
    y1: 196.5,
    x2: 413.09,
    y2: 128.1,
    gradientTransform: "translate(-263.3 -84.33)",
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-11",
    x1: 398.24,
    y1: 196.66,
    x2: 416.47,
    y2: 136.71,
    gradientTransform: "translate(-263.3 -84.33)",
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 429.77,
    y1: 209.35,
    x2: 449.65,
    y2: 132.96,
    gradientTransform: "translate(-263.3 -84.33)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6d1cbe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#8a27d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#be3bff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ca3cdc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 435.8,
    y1: 210.34,
    x2: 453.96,
    y2: 140.56,
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 443.65,
    y1: 211.79,
    x2: 461.98,
    y2: 141.36,
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 415.2,
    y1: 208.59,
    x2: 438.95,
    y2: 117.33,
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 422.28,
    y1: 208.42,
    x2: 442.82,
    y2: 129.51,
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 406.7,
    y1: 206.2,
    x2: 427.14,
    y2: 127.68,
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 390.41,
    y1: 214.49,
    x2: 423.73,
    y2: 86.49,
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 399.32,
    y1: 207.74,
    x2: 423.42,
    y2: 115.16,
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 452.4,
    y1: 212.94,
    x2: 472.07,
    y2: 137.36,
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 461.43,
    y1: 212.78,
    x2: 484.12,
    y2: 125.6,
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-12",
    x1: 464.41,
    y1: 216.18,
    x2: 478.22,
    y2: 170.74,
    gradientTransform: "translate(-263.3 -84.33)",
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-13",
    x1: 471.02,
    y1: 219.39,
    x2: 483.71,
    y2: 177.62,
    gradientTransform: "translate(-263.3 -84.33)",
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-14",
    x1: 477.03,
    y1: 219.46,
    x2: 491.5,
    y2: 171.87,
    gradientTransform: "translate(-263.3 -84.33)",
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 466.26,
    y1: 215.73,
    x2: 484.95,
    y2: 143.91,
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 472.57,
    y1: 220.57,
    x2: 486.79,
    y2: 165.93,
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 218.28,
    y1: 144.46,
    x2: 219.15,
    y2: 86.58,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-15",
    x1: 1615.5,
    y1: 225.72,
    x2: 1653.77,
    y2: 225.72,
    gradientTransform: "matrix(-1, 0, 0, 1, 2005.69, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-16",
    x1: 1654.16,
    y1: 229.33,
    x2: 1709.64,
    y2: 209.84,
    gradientTransform: "matrix(-1, 0, 0, 1, 1730.25, -84.33)",
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-17",
    x1: 1602.83,
    y1: 201.59,
    x2: 1644.7,
    y2: 201.59,
    gradientTransform: "matrix(-1, 0, 0, 1, 1730.25, -84.33)",
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 1681.02,
    y1: 237.73,
    x2: 1638.53,
    y2: 166.01,
    gradientTransform: "matrix(-1, 0, 0, 1, 2005.69, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#703ed1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5a78e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#4c9de9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#655cd9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_26-3",
    x1: 1626.92,
    y1: 231,
    x2: 1692.72,
    y2: 171.4,
    gradientTransform: "matrix(-1, 0, 0, 1, 2005.69, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_26"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 1667.25,
    cy: 195.32,
    r: 32.31,
    gradientTransform: "matrix(-1, 0, 0, 1, 2005.69, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#711f56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#6c1e52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#5c1946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#431233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#200918"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "New_Gradient_Swatch_copy_33",
    cx: 3954.31,
    cy: 1898.64,
    r: 8.59,
    gradientTransform: "matrix(-0.88, -0.47, -0.47, 0.88, 4665.89, 533.73)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eeeef0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#d1d3d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9da7b3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 3950.04,
    y1: 1877.57,
    x2: 3963.23,
    y2: 1877.57,
    gradientTransform: "matrix(-0.88, -0.47, -0.47, 0.88, 4665.89, 533.73)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6b24d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#7733dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#975ced"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#a56ef4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#955aec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#7e3de0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#702ad9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#6b24d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#712cd9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#7d3adf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6b24d6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 3952.8,
    cy: 1895.72,
    r: 17.98,
    gradientTransform: "matrix(-0.88, -0.47, -0.47, 0.88, 4665.89, 533.73)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#300b60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#1f073d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#110423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#08020f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#020004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_13",
    x1: 3211.79,
    y1: 278.6,
    x2: 3208.45,
    y2: 292.35,
    gradientTransform: "matrix(-1, 0, 0, 1, 3513.4, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6b24d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#7733dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#975ced"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a56ef4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 3952.63,
    y1: 1849.04,
    x2: 3960.44,
    y2: 1849.04,
    gradientTransform: "matrix(-0.88, -0.47, -0.47, 0.88, 4665.89, 533.73)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bec5d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#dfe2ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#e9eaf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#bec1d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#9ca1ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#848baa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#757d9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#70789c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#767ea3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#888fb5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#a5aad4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#b4b8e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#b2b6e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#9da1c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#9094ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8b90b5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: -2.34,
    y: 249.04,
    width: 12.84,
    height: 11.91,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-275.44 -84.33)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 273.29,
    y: 333.58,
    width: 12.46,
    height: 11.5,
    transform: "translate(570.29 669.06) rotate(178.07)"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "New_Gradient_Swatch_copy_33-2",
    cx: 3950.82,
    cy: 1908.69,
    r: 7.45,
    xlinkHref: "#New_Gradient_Swatch_copy_33"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-18",
    x1: 1600.36,
    y1: 234.48,
    x2: 1652.02,
    y2: 234.48,
    gradientTransform: "matrix(-1, 0, 0, 1, 2005.69, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-19",
    x1: 1652.54,
    y1: 239.35,
    x2: 1727.43,
    y2: 213.04,
    gradientTransform: "matrix(-1, 0, 0, 1, 1730.25, -84.33)",
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-20",
    x1: 1600.36,
    y1: 201.9,
    x2: 1656.88,
    y2: 201.9,
    gradientTransform: "matrix(-1, 0, 0, 1, 1730.25, -84.33)",
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 1688.8,
    y1: 250.7,
    x2: 1631.44,
    y2: 153.88,
    xlinkHref: "#linear-gradient-83"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_26-4",
    x1: 1615.77,
    y1: 241.6,
    x2: 1704.59,
    y2: 161.15,
    gradientTransform: "matrix(-1, 0, 0, 1, 2005.69, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_26"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: 1670.21,
    cy: 193.44,
    r: 43.62,
    xlinkHref: "#radial-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 3148.4,
    y1: 211.16,
    x2: 3201.3,
    y2: 305.31,
    gradientTransform: "matrix(-1, 0, 0, 1, 3513.4, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bec5d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#dfe2ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#e9eaf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#bec1d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#9ca1ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#848baa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#757d9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#70789c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#777ea2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#898eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8b90b5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: 3174.04,
    cy: 230.25,
    r: 44.93,
    gradientTransform: "matrix(-0.5, -0.86, -0.86, 0.5, 2146.33, 2864.93)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#b0fbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#363885"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 3171.35,
    y1: 194.7,
    x2: 3213.22,
    y2: 274.84,
    gradientTransform: "matrix(-1, 0, 0, 1, 3513.4, 0)",
    xlinkHref: "#linear-gradient-85"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 3204.8,
    y1: 262.6,
    x2: 3139.43,
    y2: 211.7,
    gradientTransform: "matrix(-1, 0, 0, 1, 3513.4, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#eaebf7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#cacdeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#b7badb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#9fa3c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#9095b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8b90b5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-10",
    cx: 3193.87,
    cy: 215.26,
    r: 35.81,
    gradientTransform: "matrix(-1, 0, 0, 1, 3513.4, 0)",
    xlinkHref: "#New_Gradient_Swatch_1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M496.58,323.51,437.34,289.1c-3.57-2.05-3.12-5.65,1-8l52-20c4.12-2.38,10.35-2.64,13.92-.58l39.81,23.33c3.57,2.06,3.12,5.66-1,8L510.5,322.93C506.38,325.31,500.15,325.57,496.58,323.51Z",
    transform: "translate(-275.44 -84.33)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M496.58,323.43,437.34,289a4.17,4.17,0,0,1-2.41-3.42v-4.48c0-1.56,1.18,1.15,3.41-.13l52-20c4.12-2.38,10.35-2.64,13.92-.58l39.81,23.33c1.19.68,2.05-2.23,2.36-1.31.11.31,0,4.41.05,4.73,0,1.6-1.12,3.29-3.41,4.61L510.5,322.85C506.38,325.23,500.15,325.49,496.58,323.43Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M496.58,319l-59.24-34.4c-3.57-2.06-3.12-5.66,1-8l52-20c4.12-2.38,10.35-2.64,13.92-.58l39.81,23.32c3.57,2.06,3.12,5.66-1,8L510.5,318.46C506.38,320.84,500.15,321.09,496.58,319Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M544.06,279.34,504.25,256c-3.57-2.06-9.8-1.8-13.92.58l-26.2,10.07a5.62,5.62,0,0,0,.82.56l59.24,34.41a10,10,0,0,0,2.83,1.05l16-15.31C547.18,285,547.63,281.4,544.06,279.34Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M543.06,286.63,510.5,317.71c-4.12,2.38-10.35,2.64-13.92.58l-59.24-34.41a4.24,4.24,0,0,1-2.38-3.16c-.19,1.46.59,2.88,2.38,3.91L496.58,319c3.57,2.06,9.8,1.81,13.92-.57l32.56-31.08c2.41-1.39,3.55-3.2,3.38-4.87C546.26,284,545.11,285.45,543.06,286.63Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M574,319.23,428.48,235.16c-7.43-4.3-13.46-15.82-13.46-25.73V98.16c0-9.92,6-14.48,13.46-10.18L574,172c7.44,4.3,13.47,15.82,13.47,25.73V309C587.44,319,581.41,323.52,574,319.23Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M575.71,311.48,432.27,228.61c-6-3.8-9.69-11.41-9.69-19.18v-112a2.39,2.39,0,0,1,3.6-2.06l.42.24,143.59,83c7.13,4.11,9.69,11.41,9.69,19.18V309.42a2.58,2.58,0,0,1-3.86,2.24Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M570.19,178.59l-143.59-83-.42-.24a2.39,2.39,0,0,0-3.6,2.06v112c0,7.77,3.7,15.38,9.69,19.18l143.44,82.87.31.18a2.58,2.58,0,0,0,3.86-2.24V197.77C579.88,190,577.32,182.7,570.19,178.59Zm8.17,130.83a1.07,1.07,0,0,1-1.06,1.07,1,1,0,0,1-.53-.15L433,227.3c-5.41-3.44-8.94-10.47-8.94-17.87v-112a.88.88,0,0,1,1.32-.76l144,83.23c7.39,4.26,8.93,12.07,8.93,17.87Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M577.79,170,432.3,86c-2.94-1.7-5.66-2-7.88-1.16-.28.11-4,2.1-4.3,2.25h0c2.29-1.11,5.2-.91,8.37.93L574,172c7.44,4.3,13.47,15.82,13.47,25.73V309c0,6.19-2.35,10.29-5.92,11.46a2.24,2.24,0,0,0,1.18-.4c.17-.1,4.24-2.4,4.41-2.51,2.56-1.79,4.15-5.48,4.15-10.57V195.75C591.26,185.83,585.23,174.31,577.79,170Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M574.62,171.72,429.13,87.65c-3.05-1.76-5.85-2-8.11-1a9.89,9.89,0,0,1,6.49,1.52L573,172.2c7.44,4.3,13.47,15.82,13.47,25.74V309.21c0,5.85-2.11,9.81-5.35,11.21,4.15-.66,7-4.92,7-11.7V197.45C588.09,187.53,582.06,176,574.62,171.72Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M310.54,323.4a9.76,9.76,0,0,0,4.88-1.17l59.28-33.74a5.16,5.16,0,0,0,2.8-4.46,6,6,0,0,0-3.37-5.06l-19.4-10.92a12,12,0,0,0-5.93-1.51,9.82,9.82,0,0,0-4.88,1.18l-59.28,33.74a5.15,5.15,0,0,0-2.8,4.46,6,6,0,0,0,3.37,5.06l19.4,10.92A12,12,0,0,0,310.54,323.4Z",
    transform: "translate(-275.44 -84.33)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M398.68,292.87c-22.15,0-40.05,10.29-40,23.08l25.39.05c0-2.18,1.42-4.34,4.28-6,5.72-3.3,15-3.29,20.8,0s5.8,8.7.08,12l18,10.4q11.72-6.76,11.66-16.36C438.85,303.31,420.83,292.91,398.68,292.87Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "108.64 201.57 83.26 201.52 83.26 231.66 108.64 231.66 108.64 201.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M388.37,310c5.72-3.3,15-3.29,20.8,0,2.85,1.65,4.3,3.79,4.34,5.94V286c0-2.2-1.42-4.41-4.34-6.1-5.76-3.32-15.08-3.34-20.8,0-2.83,1.63-4.25,3.76-4.27,5.91h0V316h0C384.08,313.83,385.5,311.66,388.37,310Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M427.26,302.35v30.14q11.72-6.76,11.66-16.36V286Q439,295.58,427.26,302.35Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "133.72 207.57 133.8 207.63 133.8 237.71 151.81 248.16 151.81 218.02 133.72 207.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M427.26,302,409.8,292l-.55.36,18,10.4Q439,296,438.92,286.37a2.46,2.46,0,0,0,0-.28Q438.71,295.42,427.26,302Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M398.68,262.77c-22.15,0-40.05,10.29-40,23.08l25.39,0c0-2.17,1.42-4.34,4.28-6,5.72-3.31,15-3.29,20.8,0s5.8,8.7.08,12l18,10.4Q439,295.58,438.92,286C438.85,273.21,420.83,262.81,398.68,262.77Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M413.49,286c.15-2.29-1.28-4.62-4.32-6.37-5.76-3.33-15.08-3.35-20.8,0-2.86,1.65-4.29,3.82-4.28,6l-25.36,0c0,.22,0,.44,0,.67l25.39,0c0-2.18,1.42-4.34,4.28-6,5.72-3.3,15-3.29,20.8,0C411.92,281.89,413.34,283.94,413.49,286Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-25",
    cx: 123.34,
    cy: 204.59,
    rx: 11.19,
    ry: 4.66
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M409.39,311.45l-.15.1A21.11,21.11,0,0,1,398.81,314v10.51a21.22,21.22,0,0,0,10.43-2.47l.15-.09Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M398.94,328.24l-.08-14.39h0l-.08-.09.13,25.47q16.6,0,28.32-6.73v-11Q415.54,328.27,398.94,328.24Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M409.47,311.23l-.23.15a21.24,21.24,0,0,1-10.38,2.47l.08,14.75c11.07,0,20.51-2.59,28.32-7.1Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M398.94,328l-.13-14.16v.06l.13,14.68q16.6,0,28.32-6.73l-.51-.3Q415.19,328.07,398.94,328Z",
    transform: "translate(-275.44 -84.33)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M398.85,305.29a21.47,21.47,0,0,1-10.42-2.51c-2.92-1.69-4.36-3.9-4.33-6.1h0V316h0c0,2.17,1.46,4.34,4.34,6a21.36,21.36,0,0,0,10.42,2.51Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M358.7,296.58V316c.07,12.79,18.08,23.19,40.24,23.23V319.81C376.78,319.77,358.77,309.37,358.7,296.58Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M427.26,333.47v5.88Q439,332.58,438.92,323v-5.88Q439,326.72,427.26,333.47Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M398.94,340.24l-.08-14.39h0l-.08-.09.13,20.33q16.6,0,28.32-6.73V333.5Q415.54,340.27,398.94,340.24Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M358.7,317v5.83c.07,12.79,18.08,23.19,40.24,23.23v-5.83C376.78,340.21,358.77,329.81,358.7,317Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M388.43,302.78c-2.94-1.7-4.38-3.93-4.33-6.16l-25.4,0c.07,12.79,18.08,23.19,40.24,23.23l-.08-14.52A21.51,21.51,0,0,1,388.43,302.78Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M398.81,305.2h-.19l.12,14.32c-19.8,0-36.28-8.35-39.61-19.25,2.85,11.23,19.6,19.88,39.81,19.92Z",
    transform: "translate(-275.44 -84.33)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M532.06,134.08c-5.93-3.43-10.73-.69-10.73,6.11V239c0,6.8,4.8,15.09,10.73,18.51l33.38,18.65c5.93,3.42,13.11.3,13.11-6.5V170.86c0-6.8-7.18-14.71-13.11-18.14Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M531.49,134.32c-5.93-3.42-10.73-.68-10.73,6.12v98.44c0,6.81,4.8,15.09,10.73,18.52l33.4,18.66c5.92,3.42,12.89.34,12.89-6.46V171.15c0-6.8-7-14.75-12.89-18.17Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M530.92,134.56c-5.93-3.42-10.73-.68-10.73,6.12v98.08c0,6.8,4.8,15.09,10.73,18.51L564.33,276c5.93,3.42,12.68.37,12.68-6.43V171.44c0-6.8-6.75-14.78-12.68-18.2Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M530.35,134.81c-5.93-3.43-10.73-.69-10.73,6.12v97.7c0,6.81,4.8,15.1,10.73,18.52l33.43,18.69c5.93,3.42,12.46.41,12.46-6.4v-97.7c0-6.81-6.53-14.82-12.46-18.25Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M529.78,135.05c-5.93-3.42-10.73-.68-10.73,6.12v97.34c0,6.8,4.8,15.09,10.73,18.51l33.45,18.71c5.93,3.42,12.25.44,12.25-6.37V172c0-6.8-6.32-14.85-12.25-18.28Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M529.21,135.3c-5.93-3.43-10.74-.69-10.74,6.12v97c0,6.81,4.81,15.1,10.74,18.52l33.47,18.71c5.93,3.43,12,.48,12-6.32v-97c0-6.8-6.1-14.89-12-18.31Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M528.64,135.54c-5.93-3.43-10.74-.68-10.74,6.12v96.59c0,6.81,4.81,15.1,10.74,18.53l33.48,18.72c5.94,3.43,11.82.52,11.82-6.29V172.62c0-6.81-5.88-14.93-11.82-18.35Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M528.07,135.78c-5.93-3.42-10.74-.68-10.74,6.13v96.22c0,6.8,4.81,15.1,10.74,18.52l33.5,18.74c5.93,3.43,11.61.55,11.61-6.26V172.91c0-6.81-5.68-15-11.61-18.39Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M527.51,136c-5.94-3.43-10.75-.69-10.75,6.12V238c0,6.81,4.81,15.1,10.75,18.53L561,275.28c5.93,3.43,11.39.58,11.39-6.22V173.2c0-6.8-5.46-15-11.39-18.42Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M526.94,136.27c-5.94-3.43-10.75-.68-10.75,6.12v95.49c0,6.8,4.81,15.1,10.75,18.53l33.53,18.76c5.93,3.43,11.17.62,11.17-6.19V173.5c0-6.81-5.24-15-11.17-18.46Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M526.37,136.51c-5.94-3.42-10.75-.68-10.75,6.13v95.11c0,6.81,4.81,15.11,10.75,18.53l33.54,18.78c5.94,3.43,11,.65,11-6.16V173.79c0-6.81-5-15.07-11-18.5Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M525.8,136.76c-5.94-3.43-10.75-.69-10.75,6.12v94.74c0,6.81,4.81,15.11,10.75,18.54L559.36,275c5.94,3.43,10.75.68,10.75-6.13V174.08c0-6.81-4.81-15.1-10.75-18.53Z",
    transform: "translate(-275.44 -84.33)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M525.49,135.86c-6-3.44-10.78-.69-10.78,6.15V242.86c0,6.83,4.83,15.16,10.78,18.59l33.82,18.94c6,3.44,10.78.69,10.78-6.15V173.39c0-6.83-4.83-15.16-10.78-18.59Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M559.31,154.8l-33.82-18.94c-6-3.44-10.78-.69-10.78,6.15v1c0-6.83,4.83-9.59,10.78-6.15l33.82,18.94c6,3.44,10.78,11.76,10.78,18.6v-1.05C570.09,166.56,565.26,158.23,559.31,154.8Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-53"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M542,165.12v-6.79c6.69,3.86,12.58,10.86,16.32,19.37l-4.91,1C550.93,173,546.74,167.86,542,165.12Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M542,196.7c7.61,4.39,13.77.88,13.77-7.84a26,26,0,0,0-2.35-10.19l4.91-1a41.93,41.93,0,0,1,2.17,6.16c3.72,13.87-1.55,23.78-11.76,22.15s-21.5-14.19-25.21-28l5.54.88C531,186,536,193.27,542,196.7Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M533.06,155.64l2.68,7.59c-4.46,0-7.52,3.58-7.52,9.73a22.6,22.6,0,0,0,.83,5.88l-5.54-.88C520.08,165.16,524.13,155.7,533.06,155.64Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M542,165.11a12.34,12.34,0,0,0-6.24-1.88l-2.68-7.59a16.75,16.75,0,0,1,8.93,2.69v6.79Z",
    transform: "translate(-275.44 -84.33)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-53"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M542,219.69h0v-6.9c7.7,4.45,14.4,13.12,17.77,23l-5.39-.09C552.12,229.16,547.42,222.83,542,219.69Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M542,251.28c7.61,4.39,13.77.88,13.77-7.84a24,24,0,0,0-1.4-7.74l5.39.09c2,5.77,2.5,10.66,1.64,15.22-2.08,11.1-12.46,13.14-23.19,4.56l1.15-6.11A21.1,21.1,0,0,0,542,251.28Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M539.34,249.46l-1.15,6.11a38.61,38.61,0,0,1-6.7-6.9l3.19-4A27.67,27.67,0,0,0,539.34,249.46Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M534.68,244.65l-3.19,4a45,45,0,0,1-8.62-18.35l5.81,1.57A32.08,32.08,0,0,0,534.68,244.65Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M542,212.78v6.9c-7.6-4.37-13.75-.86-13.75,7.86a22,22,0,0,0,.46,4.35l-5.81-1.57a28,28,0,0,1-.68-6.26C522.19,211.53,531.05,206.48,542,212.78Z",
    transform: "translate(-275.44 -84.33)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M532.24,175.28c0,6.17,4.37,13.71,9.74,16.81s9.75.61,9.75-5.56-4.37-13.7-9.75-16.8S532.24,169.12,532.24,175.28Zm10.35-3.69a12,12,0,0,1,2.73,5.25,16.91,16.91,0,0,1-2.73-1.19Zm3.12,6.81a24.93,24.93,0,0,1,.52,4.26l-3.64-2.1v-3.51A18.87,18.87,0,0,0,545.71,178.4Zm.52,5.66a15.79,15.79,0,0,1-.52,3.66,26.55,26.55,0,0,0-3.12-2.25V182Zm-.91,4.77c-.67,1.55-1.64,2.35-2.73,2.1v-4.06A23.84,23.84,0,0,1,545.32,188.83Zm-3.94,1.39a11.75,11.75,0,0,1-2.73-5.24,16.91,16.91,0,0,1,2.73,1.19Zm-3.12-6.81a22.87,22.87,0,0,1-.52-4.25l3.64,2.1v3.51A18.15,18.15,0,0,0,538.26,183.41Zm-.52-5.65a14.78,14.78,0,0,1,.52-3.66,26.47,26.47,0,0,0,3.12,2.24v3.52Zm.91-4.78c.67-1.54,1.63-2.34,2.73-2.09V175A23.93,23.93,0,0,1,538.65,173Zm-1.2-1c-.5-.48-1-1-1.4-1.46a4.65,4.65,0,0,1,2.68-.48A5.33,5.33,0,0,0,537.45,171.93Zm7.79,1.82a20.31,20.31,0,0,1,2.68,3.57,7.26,7.26,0,0,1-1.41-.16A20.33,20.33,0,0,0,545.24,173.75Zm3.51,5.13a17,17,0,0,1,1.73,6.23l-3-1.75a26.27,26.27,0,0,0-.56-4.65A7.75,7.75,0,0,0,548.75,178.88Zm1.73,7.63a6.16,6.16,0,0,1-1.73,4.24,24.55,24.55,0,0,0-1.86-2,16.77,16.77,0,0,0,.56-4Zm-2.56,4.84a4.65,4.65,0,0,1-2.68.48,5.4,5.4,0,0,0,1.27-1.94C547,190.36,547.48,190.85,547.92,191.35Zm-9.19-3.28a20.69,20.69,0,0,1-2.68-3.57,7.24,7.24,0,0,1,1.4.16A20.66,20.66,0,0,0,538.73,188.07Zm-3.51-5.13a17.12,17.12,0,0,1-1.73-6.24l3,1.75a26.39,26.39,0,0,0,.56,4.66A7.27,7.27,0,0,0,535.22,182.94Zm-1.73-7.63a6.14,6.14,0,0,1,1.73-4.24,22.88,22.88,0,0,0,1.86,2,16.92,16.92,0,0,0-.56,4Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M532.24,229.86c0,6.18,4.36,13.7,9.74,16.8s9.74.62,9.74-5.55-4.36-13.69-9.74-16.8S532.24,223.69,532.24,229.86Zm2,1.13c0-4.94,3.49-6.93,7.79-4.44s7.8,8.5,7.8,13.44-3.49,6.92-7.8,4.44S534.19,235.93,534.19,231Zm1.95,1.12A12.88,12.88,0,0,0,542,242.19c3.23,1.87,5.85.38,5.85-3.33A12.88,12.88,0,0,0,542,228.78C538.76,226.92,536.14,228.41,536.14,232.11Zm2,1.13c0-2.47,1.74-3.47,3.89-2.22a8.56,8.56,0,0,1,3.9,6.72c0,2.47-1.74,3.46-3.9,2.22A8.58,8.58,0,0,1,538.09,233.24Zm1.95,1.12a4.29,4.29,0,0,0,1.94,3.36c1.08.62,1.95.13,1.95-1.11a4.29,4.29,0,0,0-1.95-3.36C540.91,232.63,540,233.13,540,234.36Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-64"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-65",
    points: "245.4 250.44 255.64 256.35 255.64 252.19 245.4 246.28 245.4 250.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "255.64 256.35 265.88 250.44 265.88 246.28 255.64 252.19 255.64 256.35"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-64"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "260.08 263.42 270.32 269.33 270.32 261.05 260.08 255.14 260.08 263.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "270.32 269.33 280.56 263.42 280.56 255.14 270.32 261.05 270.32 269.33"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-64"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "274.94 275.42 285.18 281.33 285.18 268.93 274.94 263.02 274.94 275.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "285.17 281.33 295.41 275.42 295.41 263.02 285.17 268.93 285.17 281.33"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-64"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "289.62 288.4 299.86 294.32 299.86 277.79 289.62 271.88 289.62 288.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "299.86 294.32 310.1 288.4 310.1 271.88 299.86 277.79 299.86 294.32"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-64"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "304.82 300.42 315.06 306.34 315.06 285.69 304.82 279.78 304.82 300.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "315.05 306.34 325.29 300.42 325.29 279.78 315.05 285.69 315.05 306.34"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "255.64 228.62 245.41 234.54 255.65 240.45 265.88 234.53 255.64 228.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "245.4 244.87 255.64 250.78 255.64 240.44 245.4 234.53 245.4 244.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "255.64 250.78 265.88 244.87 265.88 234.53 255.64 240.44 255.64 250.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-74",
    points: "255.64 250.78 265.88 244.87 265.88 234.53 255.64 240.44 255.64 250.78"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "265.88 234.53 255.69 240.02 245.4 234.53 255.33 240.67 255.64 250.78 256.13 240.6 265.88 234.53"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "270.32 215.28 260.09 221.2 270.33 227.11 280.56 221.19 270.32 215.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "260.08 253.89 270.32 259.8 270.32 227.11 260.08 221.19 260.08 253.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-78",
    points: "270.32 259.8 280.56 253.89 280.56 221.19 270.32 227.11 270.32 259.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-79",
    points: "270.32 259.8 280.56 253.89 280.56 221.19 270.32 227.11 270.32 259.8"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "280.56 221.19 270.37 226.68 260.08 221.19 270.01 227.33 270.32 259.8 270.81 227.26 280.56 221.19"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-81",
    points: "285.11 201.03 274.88 206.95 285.11 212.86 295.34 206.95 285.11 201.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-82",
    points: "274.87 261.85 285.11 267.76 285.11 212.86 274.87 206.95 274.87 261.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "285.11 267.76 295.34 261.85 295.34 206.95 285.11 212.86 285.11 267.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "285.11 267.76 295.34 261.85 295.34 206.95 285.11 212.86 285.11 267.76"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "295.34 206.95 285.16 212.43 274.87 206.95 284.8 213.08 285.11 267.76 285.59 213.01 295.34 206.95"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-86",
    points: "299.94 186.42 289.71 192.33 299.95 198.25 310.18 192.33 299.94 186.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "289.7 270.32 299.94 276.23 299.94 198.24 289.7 192.33 289.7 270.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "299.94 276.23 310.18 270.32 310.18 192.33 299.94 198.24 299.94 276.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "299.94 276.23 310.18 270.32 310.18 192.33 299.94 198.24 299.94 276.23"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "310.18 192.33 299.99 197.81 289.7 192.33 299.63 198.47 299.94 276.23 300.43 198.39 310.18 192.33"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-91",
    points: "315.18 172.07 304.94 177.99 315.18 183.9 325.41 177.98 315.18 172.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-92",
    points: "304.93 278.79 315.17 284.7 315.17 183.89 304.93 177.98 304.93 278.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "315.17 284.7 325.41 278.79 325.41 177.98 315.17 183.89 315.17 284.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-94",
    points: "315.17 284.7 325.41 278.79 325.41 177.98 315.17 183.89 315.17 284.7"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-95",
    points: "325.41 177.98 315.22 183.47 304.93 177.98 314.86 184.12 315.17 284.7 315.66 184.04 325.41 177.98"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-96"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M410.56,91.45c-7.84-4.52-14.19-.9-14.19,8.09v69.65c0,9,6.35,19.95,14.19,24.47L499.06,244c7.84,4.52,17.33.4,17.33-8.59V165.79c0-9-9.49-19.45-17.33-24Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M410.6,92.84c-7.73-4.46-14-.89-14,8v68.7c0,8.88,6.28,19.7,14,24.17l87.77,50c7.74,4.47,16.87.44,16.87-8.44V166.53c0-8.88-9.13-19.25-16.87-23.72Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M410.65,94.24c-7.64-4.42-13.83-.88-13.83,7.88v67.74c0,8.77,6.19,19.46,13.83,23.87l87,49.57c7.64,4.41,16.41.48,16.41-8.29V167.27c0-8.77-8.77-19.05-16.41-23.46Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M410.7,95.63c-7.54-4.36-13.66-.87-13.66,7.79v66.77c0,8.66,6.12,19.21,13.66,23.57L497,242.94c7.55,4.36,16,.51,16-8.15V168c0-8.66-8.4-18.85-16-23.21Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M410.75,97c-7.45-4.3-13.49-.86-13.49,7.69v65.82c0,8.55,6,19,13.49,23.26l85.55,48.79c7.45,4.3,15.49.54,15.49-8V168.75c0-8.55-8-18.65-15.49-22.95Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M410.8,98.41c-7.35-4.25-13.31-.85-13.31,7.59v64.86c0,8.44,6,18.72,13.31,23l84.81,48.39c7.35,4.24,15,.57,15-7.87V169.49c0-8.44-7.68-18.45-15-22.69Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M410.85,99.8c-7.26-4.19-13.14-.84-13.14,7.49v63.9c0,8.33,5.88,18.48,13.14,22.67l84.07,48c7.26,4.19,14.57.61,14.57-7.71V170.23c0-8.33-7.31-18.25-14.57-22.44Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M410.9,101.19c-7.16-4.14-13-.83-13,7.39v63c0,8.21,5.8,18.23,13,22.36l83.33,47.6c7.16,4.14,14.11.65,14.11-7.57V171c0-8.22-6.95-18.05-14.11-22.18Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M411,102.58c-7.06-4.08-12.79-.81-12.79,7.29v62c0,8.11,5.73,18,12.79,22.06l82.59,47.21c7.06,4.08,13.65.68,13.65-7.43v-62c0-8.1-6.59-17.85-13.65-21.93Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M411,104c-7-4-12.62-.8-12.62,7.19v61c0,8,5.65,17.74,12.62,21.77l81.85,46.81c7,4,13.19.71,13.19-7.29v-61c0-8-6.22-17.65-13.19-21.67Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M411.05,105.36c-6.87-4-12.44-.79-12.44,7.09v60.08c0,7.88,5.57,17.49,12.44,21.46l81.11,46.41c6.87,4,12.73.75,12.73-7.13V173.19c0-7.88-5.86-17.45-12.73-21.42Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M411.1,106.75c-6.78-3.91-12.27-.78-12.27,7v59.11c0,7.78,5.49,17.25,12.27,21.16l80.37,46c6.77,3.91,12.26.78,12.26-7V173.93c0-7.77-5.49-17.25-12.26-21.16Z",
    transform: "translate(-275.44 -84.33)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M411,98.61c-7.06-4.08-12.78-.82-12.78,7.28V174.5c0,8.1,5.72,18,12.78,22.05l83.72,47.94c7.06,4.08,12.78.82,12.78-7.28V168.6c0-8.1-5.72-18-12.78-22Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M494.76,146.55,411,98.61c-7.06-4.08-12.78-.82-12.78,7.28v1.24c0-8.1,5.72-11.36,12.78-7.29l83.72,47.95c7.06,4.07,12.78,13.94,12.78,22V168.6C507.54,160.5,501.82,150.63,494.76,146.55Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "172.54 69.12 168.87 66.94 168.87 120.32 172.54 122.5 172.54 69.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-112",
    points: "179.32 66.31 175.65 64.12 175.65 124.18 179.32 126.36 179.32 66.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-113",
    points: "186.31 59.14 182.64 56.95 182.64 128.17 186.31 130.35 186.31 59.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-114",
    points: "154.9 74.03 154.9 112.11 158.57 114.29 158.57 76.21 154.9 74.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-115",
    points: "165.56 84.43 161.89 82.24 161.89 116.1 165.56 118.28 165.56 84.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-116",
    points: "193.16 72.95 189.49 70.76 189.49 132.16 193.16 134.34 193.16 72.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-117",
    points: "199.87 87.86 196.21 85.67 196.21 136.08 199.87 138.27 199.87 87.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "151.59 61.91 147.92 59.73 147.92 98.9 151.59 110.08 151.59 61.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "133.95 70.91 133.95 90.68 137.62 101.87 137.62 73.09 133.95 70.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-120",
    points: "144.6 62.62 140.94 60.44 140.94 103.67 144.6 105.86 144.6 62.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-121",
    points: "206.5 93.55 202.84 91.37 202.84 139.88 206.5 142.06 206.5 93.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-122",
    points: "213.29 89.64 209.62 87.45 209.62 143.73 213.29 145.92 213.29 89.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-123",
    points: "220.27 78.05 216.6 75.86 216.6 147.72 220.27 149.91 220.27 78.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "172.54 72.56 168.87 70.38 168.87 123.76 172.54 125.94 172.54 72.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-125",
    points: "179.32 78.4 175.65 76.21 175.65 127.62 179.32 129.8 179.32 78.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-126",
    points: "186.31 74.41 182.64 72.23 182.64 131.61 186.31 133.79 186.31 74.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-127",
    points: "154.9 77.47 154.9 115.55 158.57 117.73 158.57 79.65 154.9 77.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-128",
    points: "165.56 86.02 161.89 83.84 161.89 119.54 165.56 121.72 165.56 86.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-129",
    points: "193.16 82.63 189.49 80.44 189.49 135.6 193.16 137.78 193.16 82.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "199.87 91.3 196.21 89.11 196.21 139.52 199.87 141.71 199.87 91.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-131",
    points: "151.59 71.89 147.92 69.7 147.92 111.33 151.59 113.52 151.59 71.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-132",
    points: "133.95 74.35 133.95 103.12 137.62 105.31 137.62 76.53 133.95 74.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-133",
    points: "144.6 66.06 140.94 63.88 140.94 107.11 144.6 109.3 144.6 66.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-134",
    points: "172.54 93.78 168.87 91.6 168.87 123.76 172.54 125.94 172.54 93.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-135",
    points: "179.32 86.1 175.65 83.91 175.65 127.62 179.32 129.8 179.32 86.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-136",
    points: "186.31 91.7 182.64 89.51 182.64 131.61 186.31 133.79 186.31 91.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-137",
    points: "154.9 93.61 154.9 115.55 158.57 117.73 158.57 95.8 154.9 93.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-138",
    points: "165.56 92.22 161.89 90.03 161.89 119.54 165.56 121.72 165.56 92.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-139",
    points: "151.59 83.64 147.92 81.46 147.92 111.33 151.59 113.52 151.59 83.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-140",
    points: "133.95 88.4 133.95 103.12 137.62 105.31 137.62 90.58 133.95 88.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-141",
    points: "144.6 87.87 140.94 85.69 140.94 107.11 144.6 109.3 144.6 87.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-142",
    points: "193.16 104.61 189.49 102.43 189.49 135.6 193.16 137.78 193.16 104.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-143",
    points: "199.87 118 196.21 115.82 196.21 139.59 199.87 141.78 199.87 118"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-144",
    points: "206.5 96.99 202.84 94.81 202.84 143.31 206.5 145.5 206.5 96.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-145",
    points: "213.29 98.38 209.62 96.19 209.62 147.17 213.29 149.36 213.29 98.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-146",
    points: "220.27 88.19 216.6 86.01 216.6 151.16 220.27 153.35 220.27 88.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-147",
    points: "206.5 106.38 202.84 104.2 202.84 143.31 206.5 145.5 206.5 106.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-148",
    points: "213.29 108.57 209.62 106.38 209.62 147.17 213.29 149.36 213.29 108.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-149",
    points: "220.27 116.45 216.6 114.26 216.6 151.16 220.27 153.35 220.27 116.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M351.92,206.55v46.18c17.78-10.27,32.78-31.43,38.27-54Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-151",
    points: "76.47 168.39 72.88 166.29 72.94 120.63 76.47 122.22 76.47 168.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-152",
    points: "114.75 114.39 111.15 112.29 72.88 120.12 76.47 122.22 114.75 114.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M318,208.74c5.21-21.38,22.41-41.37,38.42-44.64,4.82-1,9-.34,12.29,1.61l0,0,4.65,3.45-.31.5c4.43,5.84,5.78,15.53,2.93,27.25l-22.64,4.63L347,211.81v26a30,30,0,0,1-9.42,3.73,18.58,18.58,0,0,1-8.85-.16l-.48.78s-4.46-3.23-5-3.69l-.69-.51.05-.08C316.91,232.38,314.86,221.82,318,208.74Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M350.64,205.51l29-5.93c5.2-21.38-3.56-36.06-19.58-32.78s-33.22,23.26-38.42,44.64,3.56,36.07,19.58,32.79a30,30,0,0,0,9.42-3.73Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M321.4,211.2c5.2-21.38,22.41-41.37,38.42-44.64a19.39,19.39,0,0,1,7.36-.19,19.89,19.89,0,0,0-6.31.34c-16,3.27-33.22,23.26-38.42,44.64-4.34,17.83,1,31,12.22,33C322.78,243,316.93,229.58,321.4,211.2Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M276.71,326.37a5.38,5.38,0,1,0,7.29-2.18A5.4,5.4,0,0,0,276.71,326.37Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M298.05,284.7,309.7,291,288,330.87h0l0,.05c-1,1.88-4.43,2-7.65.25s-5-4.65-4-6.53l0,0h0Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M298.05,284.7,309.7,291,288,330.87h0l0,.05c-1,1.88-4.43,2-7.65.25s-5-4.65-4-6.53l0,0h0Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M298,284.72c-1,1.87.78,4.8,4,6.53s6.64,1.62,7.65-.25-.78-4.8-4-6.53S299.05,282.85,298,284.72Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M304.89,277.79l6.93,3.74-4.14,7.54h0v0c-.6,1.11-2.64,1.18-4.55.15s-3-2.77-2.38-3.89l0,0h0Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-161"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M276,337.25a4.67,4.67,0,1,0,6.32-1.89A4.67,4.67,0,0,0,276,337.25Z",
    transform: "translate(-275.44 -84.33)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-163"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M353.67,208.6v62.33c24-13.85,44.25-42.42,51.66-72.89Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-165",
    points: "78.23 186.6 73.37 183.77 73.45 122.13 78.23 124.27 78.23 186.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "129.89 113.7 125.03 110.87 73.37 121.44 78.23 124.27 129.89 113.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M307.94,211.57c7-28.87,30.25-55.85,51.87-60.27,6.5-1.33,12.1-.46,16.58,2.18l0,0,6.28,4.66-.42.68c6,7.88,7.8,21,4,36.78l-30.55,6.25-8.59,13.9v35.09a40.63,40.63,0,0,1-12.72,5,25.15,25.15,0,0,1-11.95-.21l-.64,1s-6-4.35-6.76-5l-.93-.68.06-.11C306.41,243.48,303.65,229.22,307.94,211.57Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M352,207.2l39.14-8c7-28.87-4.8-48.68-26.42-44.26s-44.85,31.4-51.87,60.27,4.81,48.68,26.43,44.26a40.91,40.91,0,0,0,12.72-5Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "M312.48,214.88c7-28.86,30.24-55.84,51.86-60.26a26.4,26.4,0,0,1,9.93-.26,27.43,27.43,0,0,0-8.51.46c-21.62,4.42-44.84,31.4-51.87,60.27-5.85,24.06,1.4,41.82,16.5,44.51C314.34,257.79,306.44,239.69,312.48,214.88Z",
    transform: "translate(-275.44 -84.33)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M328.52,276.5c18.31-10.57,33.15-36.17,33.15-57.18,0-8.43-2.39-14.85-6.45-18.82,7.72,2.51,12.67,10.46,12.67,22.6,0,21-14.84,46.61-33.14,57.18-11,6.32-20.67,5.83-26.7-.08C313.68,282,320.8,281,328.52,276.5Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-171",
    cx: 333.15,
    cy: 241.1,
    rx: 44.23,
    ry: 25.53,
    transform: "translate(-318.57 322.7) rotate(-59.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M327.72,200.19c9-5.2,17.16-5.79,23.14-2.56.16.09,8.74,4.88,9,5.29-6.08-4.58-15.08-4.51-25.12,1.28-18.31,10.57-33.15,36.17-33.15,57.18,0,10.72,3.86,18.17,10.08,21.49a7.4,7.4,0,0,1-1.62-.71l-6.19-3.75c-5.76-3.51-9.3-10.78-9.3-21C294.57,236.36,309.41,210.76,327.72,200.19Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "M301.6,261.38c0,21,14.84,29.47,33.15,18.9s33.14-36.17,33.14-57.18-14.84-29.47-33.14-18.9S301.6,240.37,301.6,261.38Zm2.77-1.07c0-19.39,13.71-43,30.61-52.79s30.6-1.94,30.6,17.45-13.7,43-30.6,52.79S304.37,279.71,304.37,260.31Z",
    transform: "translate(-275.44 -84.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M333.16,203.41c8.77-5.07,16.75-5.75,22.68-2.79-5.53-1.54-13.66-.71-21.09,3.58-18.31,10.57-33.15,36.17-33.15,57.18,0,10.94,5.3,18.78,11.74,22-8.09-2.26-13.33-10.31-13.33-22.8C300,239.58,314.85,214,333.16,203.41Z",
    transform: "translate(-275.44 -84.33)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.533af60f984bb6a6208285caf93d6dbb.svg";
export { ForwardRef as ReactComponent };